import { SAGA_ACTIONS } from '../../../_config';
import { useApiCall } from '../appApiCallHook';

export function useChatHistoryApi() {
  const callApi = useApiCall();

  const getSessions = (onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CHAT_SESSIONS.GET, {}, onSuccess, onError);
  };

  const createSession = (onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CHAT_SESSIONS.CREATE, {}, onSuccess, onError);
  };

  const deleteSession = (session_id: string, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CHAT_SESSIONS.DELETE, { session_id }, onSuccess, onError);
  };

  const getMessages = (session_id: string, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CHAT_SESSIONS.MSGS, { session_id }, onSuccess, onError);
  };

  const sendQuery = (session_id: string, question: string, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CHAT_SESSIONS.QUERY, { session_id, question }, onSuccess, onError);
  };

  return { getSessions, createSession, deleteSession, getMessages, sendQuery };
}
